import React, { FC } from "react";
import { CheckIcon } from "./Question/QuestionPackage";

type Props = {
  data: {
    levelRange: [number, number];
    levelFeatures: {
      [key: number]: {
        label: string;
        features: string[];
      };
    };
  };
  currentLevel: number;
  onSelectLevel: (level: number) => void;
};

const CustomRangeFeature: FC<Props> = ({
  data,
  currentLevel,
  onSelectLevel,
}) => {
  return (
    <React.Fragment>
      <div className="mb-2 w-full px-8">
        <span className="text-sm font-bold text-neutral-600 block text-center">
          {data.levelFeatures[currentLevel].label}
        </span>
        <div id="" className="" style={{ opacity: 1 }}>
          <div
            style={{
              transform: "scale(1)",
              cursor: "pointer",
              height: "36px",
              display: "flex",
              width: "100%",
            }}
          >
            <div
              className="bg-secondary/60"
              style={{
                height: "5px",
                width: "100%",
                borderRadius: "4px",
                alignSelf: "center",
              }}
            >
              <div
                className="bg-secondary cursor-pointer"
                style={{
                  position: "absolute",
                  left: "-2px",
                  marginTop: "-6px",
                  height: "16px",
                  width: "5px",
                }}
                onClick={() => onSelectLevel(1)}
              ></div>
              <div
                className="bg-secondary cursor-pointer"
                style={{
                  position: "absolute",
                  left: "96px",
                  marginTop: "-6px",
                  height: "16px",
                  width: "5px",
                }}
                onClick={() => onSelectLevel(2)}
              ></div>
              <div
                className="bg-secondary cursor-pointer"
                style={{
                  position: "absolute",
                  left: "194px",
                  marginTop: "-6px",
                  height: "16px",
                  width: "5px",
                }}
                onClick={() => onSelectLevel(3)}
              ></div>
              <div
                aria-valuemax={data.levelRange[1]}
                aria-valuemin={data.levelRange[0]}
                aria-valuenow={currentLevel}
                draggable="false"
                role="slider"
                style={{
                  position: "absolute",
                  zIndex: 0,
                  cursor: "grab",
                  userSelect: "none",
                  touchAction: "none",
                  height: "30px",
                  width: "30px",
                  borderRadius: "50%",
                  backgroundColor: "rgb(255, 255, 255)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  boxShadow: "rgb(170, 170, 170) 0px 2px 6px",
                  transform: `translate(${
                    (currentLevel - data.levelRange[0]) * 98 - 10
                  }px, -12.5px)`,
                  pointerEvents: "auto",
                }}
                tabIndex={0}
                onMouseDown={(e) => {
                  const slider = e.currentTarget;
                  const startX = e.clientX;
                  const startLevel = currentLevel;

                  const handleMouseMove = (e: MouseEvent) => {
                    const dx = e.clientX - startX;
                    const levelChange = Math.round(dx / 98);
                    const newLevel = Math.max(
                      data.levelRange[0],
                      Math.min(data.levelRange[1], startLevel + levelChange)
                    );
                    if (newLevel !== currentLevel) {
                      onSelectLevel(newLevel);
                    }
                  };

                  const handleMouseUp = () => {
                    document.removeEventListener("mousemove", handleMouseMove);
                    document.removeEventListener("mouseup", handleMouseUp);
                    slider.style.cursor = "grab";
                  };

                  slider.style.cursor = "grabbing";
                  document.addEventListener("mousemove", handleMouseMove);
                  document.addEventListener("mouseup", handleMouseUp);
                }}
                onKeyDown={(e) => {
                  if (e.key === "ArrowLeft") {
                    const newLevel = Math.max(
                      data.levelRange[0],
                      currentLevel - 1
                    );
                    onSelectLevel(newLevel);
                  } else if (e.key === "ArrowRight") {
                    const newLevel = Math.min(
                      data.levelRange[1],
                      currentLevel + 1
                    );
                    onSelectLevel(newLevel);
                  }
                }}
                onClick={() => onSelectLevel(currentLevel)}
              >
                <div
                  className="bg-primary"
                  style={{ height: "16px", width: "5px" }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ul className="space-y-5">
        {data.levelFeatures[currentLevel].features.map((feature, index) => (
          <li key={index} className="flex items-center gap-1.5 text-left">
            <div className="flex-shrink-0">
              <CheckIcon />
            </div>
            <span className="text-xs font-medium">{feature}</span>
          </li>
        ))}
      </ul>
    </React.Fragment>
  );
};

export default CustomRangeFeature;
